import { Assets } from '../theme/assets'

export const ThumbnailData = [
  {
    id: 6,
    link: '/project/project6',
    image: Assets.p6preview,
    imagedetail: Assets.p6detail,
    title: 'Rider',
    technology: 'UX/UI Design, User Research, Wireframing, Adobe XD',
    summary: 'Bike Sharing Application Redesign',
    jpsummary: 'いつも使用している自転車シェアアプリケーションの再設計及びリデザインを行った',
    enchallenge:["Complicated User Registration","Not easy to unlock each bicycle","English option wasn't available", "It was hard to reach to the page for checking usage history"],
    jpchallenge: ["利用登録画面が複雑であり、簡単に利用が始められない", "自転車の解除方法の理解が難しい", "英語への対応なし", "利用履歴等確認が複雑であった"],
    engoal:'The member registration screen has been simplified and a login link to other services has been added, the English and Japanese languages switch feature has been added, the method of unlocking the bicycle has been made easier to select, the battery level of the bicycle has been displayed, and usage information can be easily checked from the tabs.',
    jpgoal: '会員登録画面の簡素化と他サービスとのログイン連携機能の追加、英語と日本語の言語切り替え機能、自転車の解錠方法を選択しやすくし、自転車のバッテリーレベルを表示、利用情報等も容易にタブから確認できるように変更した。',
    enrole:'User Research, Wireframing, UX/UI Design',
    jprole:'ユーザーリサーチ、ワイヤーフレーム作成、UX/UIデザインを担当',
    projectLink: ''
  },
  {
    id: 5,
    link: '/project/project5',
    image: Assets.p5preview,
    imagedetail: Assets.p5detail,
    title: 'Public Dashboard',
    technology: 'HTML5, CSS3(SCSS), JavaScript, React.js, Adobe XD',
    summary: 'Public Dashboard is a website builder to show tracked strategic plans by Envisio Software to public. It was a big renewal of the application after three years and passed Accessibility test for the rank AAA.',
    jpsummary: 'カナダの政府系ソフトウェア会社にて、北米の自治体向けのWebサイトビルダープロジェクトに参加。三年ぶりの全面的なリニューアルを3ヶ月かけて実行した。アクセシビリティテストAAAを獲得。',
    enchallenge:["There was no navigation menu for users to click into multiple pages from langing page","It was not clear which pages in the admin panel where users can customize the site would add which features","There were several pages and components which is not passing Accessibility test"],
    jpchallenge: ["多数のページをユーザーが追加した際にページに飛ぶメニューが存在しなかった", "ユーザーがサイトをカスタムする管理画面のどのページがどの機能を追加するか明確でなかった", "アクセシビリティテストを通過しないデザインが多数あった"],
    engoal:'Created Dropdown Menu and Hamburger Menu so that users could customize which menu they could add to the website',
    jpgoal: 'ユーザーが管理画面から追加したいメニューを選べるように、ドロップダウンメニューとハンバーガーメニューのデザインと実装を行った。管理画面のカスタム画面も、どのページにどの機能を追加、削除できるか明確に追加し、サイトの全てのページでアクセスビリティテスト通過の実験を行い合格した。',
    enrole:'My role was a designer and Front-end developer in this project. I focused on User Research, Wireframing, UX/UI Design, React.js coding',
    jprole:'プロダクトマネージャー、バックエンドエンジニアと密にコミュニケーションを取り、ユーザーリサーチ、ワイヤーフレーム作成、UX/UIデザイン、React.jsを使用したコーディングを主に担当',
    projectLink: 'https://performance.envisio.com/dashboard/bayview/'
  },
  {
    id: 4,
    link: '/project/project4',
    image: Assets.p4preview,
    imagedetail: Assets.p4preview,
    title: 'Find My Cosmetics',
    technology: 'HTML5, CSS3, JavaScript, React.js, Make up API',
    summary: 'Web API Search application project using React.js and Makeup API. Users can search different types of cosmetics. By typing keywords or selecting category options, it shows product names, brand names, categories such as Organic, Dairy Free, Vegan and so on.',
    jpsummary: 'Makeup APIを使用し、アレルギーやオーガニックを気にする人が肌に合う化粧品を検索できるように情報を検索できるアプリケーションを作成。',
    enchallenge:["Designing React component and coding","Obtaining data from Make Up API","Filtering of acquired data"],
    jpchallenge: ["Reactコーディングを意識したデザインとReactを利用したコンポーネント作成", "Make Up APIを利用したデータ取得", "取得したデータのフィルタリング"],
    engoal:'Got tag data from the API and created filter feature by selecting tags',
    jpgoal: 'APIのデータの中でタグを取得できることを見つけ、アレルギーなどのタグを選択することによってフィルター機能を追加',
    enrole:'My role in this project was UX/UI Designer and React Developer',
    jprole:'UX/UIデザインとReact.jsを使用した実装を担当',
    projectLink: 'https://beach1208.github.io/Find-My-Cosmetics/',
  },
  {
    id: 3,
    link: '/project/project3',
    image: Assets.p3preview,
    imagedetail: Assets.p3detail,
    title: 'Layla Ballet',
    technology: 'HTML5, CSS3(SCSS), JavaScript, jQuery, Adobe XD',
    summary: 'Layla Ballet is a ballet studio website. Since this ballet studio has more adult students, I carefully designed font size and layout of the website so that users could find information easily.',
    jpsummary: '母が経営するバレエスタジオのWebサイトを作成。大人の生徒さんが多く、これからのメインターゲットも40代以上であったため、落ち着いたデザインと大きめのフォントや値段表示をデザインに取り込んだ。',
    enchallenge:["Defining requirements for site creation","Create the studio schedule layout","Responsive Website", "Adding animation"],
    jpchallenge: ["サイト作成にあたっての要件定義", "スタジオスケジュールレイアウトの表示", "レスポンシブ対応", "アニメーション対応"],
    engoal:'I used libraries such as Scroll Reveal and ANIMSITION to make all pages responsive, and to create animations and scrolling animations for each page change',
    jpgoal: '全ページでのレスポンシブ対応及び、各ページ切り替えにおけるアニメーションやスクロールアニメーションをScroll RevealやANIMSITIONなどのライブラリを使用し、実現させた',
    enrole:'I focused on UX/UI Design, Front-end coding and animation coding',
    jprole:'UX/UIデザイン、フロントエンド実装とアニメーションの実装を担当',
    projectLink: 'https://beach1208.github.io/LaylaBallet/'
  },
  {
    id: 2,
    link: '/project/project2',
    image: Assets.p2preview,
    imagedetail: Assets.p2detail,
    title: 'LA NATURE',
    technology: 'HTML5, CSS3(SCSS), JavaScript, PHP, WordPress, Sketch',
    summary: 'LA NATURE is original WordPress blog theme. I targeted female 20s bloggers first of all, and started from Web Design using Sketch App. After I made a foundation of the theme with HTML5, I converted all HTML files to PHP files.',
    jpsummary: 'ターゲットを女性ブロガーとして意識したWordPressテーマを、Sketchでデザインを作成し、実装まで行いました。',
    enchallenge:["Implementing PHP coding using WordPress from web design","Defining the components needed for blog design"],
    jpchallenge: ["WebデザインからWordPressを利用したPHPコーディングの実装", "ブログデザインに必要なコンポーネントの定義"],
    engoal:'Created an original theme and learned how to conver HTML base website to PHP base WordPress website',
    jpgoal: 'このテーマを完成させることによって、HTMLベースで作成したサイトをPHPに変換させ、WordPressサイトとして実装、立ち上げる方法を学んだ',
    enrole:'I focused on Web Design, PHP Coding and understanding WordPress structure',
    jprole:'Webデザイン、PHPコーディング、WordPressテーマ作成の実装を担当',
    projectLink: 'https://github.com/beach1208/LA-NATURE'
  },
  {
    id: 1,
    link: '/project/project1',
    image: Assets.p1preview,
    imagedetail: Assets.p1preview,
    title: 'Recipe Flicker',
    technology: 'Sketch, Illustrator, Zepplin, UX/UI Design',
    summary: 'Recipe Flicker is a school group project I worked with two other iOS Developers. We decided to make a recipe suggestion app for those who can not decide what to cook and eat.',
    jpsummary: 'プログラミングスクールのiOSグループ課題で、何を食べたいかレシピが決まらない忙しい社会人や学生向けに、Tinder風のUIでレシピをおすすめするアプリRecipe Flickerを開発',
    enchallenge:["Design components based on iOS design guidelines","lNeeded to understand what kind of design could be implemented in an iOS appist2","Needed to create a screen for saving recipes by category"],
    jpchallenge: ["iOSデザインガイドラインを元にコンポーネントをデザイン", "iOSアプリに置いてどのようなデザインを実装可能か理解する必要があった", "カテゴリー別のレシピの保存画面の作成"],
    engoal:'The design was created in consultation with the engineers, who were able to actually implement it based on the design, and user feedback was obtained. We communicated closely with the engineers so that they could reproduce the design in every detail, and then implemented it.',
    jpgoal: 'デザインを元に実際に実装が可能がエンジニアと相談しながらデザインを作成し、ユーザーフィードバックも取得。エンジニアが細かいところまでデザインを再現できるよう、密にコミュニケーションを取り、実装を行った',
    enrole:'I implemented users and competitors research first, then worked from wireframing to prototyping with Sketch App. I also made an icon with Sketch and illustrator.',
    jprole:'ユーザーリサーチ、競合リサーチなどを行い、Sketchを用いてワイヤーフレーミング、プロトタイピングを担当し、アプリのロゴも作成',
    projectLink: 'https://github.com/KentaKodashima/RecipeFlicker'
  }
]